<app-display-header>
  <div class="track-info">
    <div class="label">kolosek <span>track</span></div>
    <div class="track-id">{{ track }}</div>
  </div>
</app-display-header>
<div class="message" [class.won]="!notifications?.length">
  <p>Dobrodošli na železničku stanicu</p>
  <p class="text-white">Welcome to railway station</p>
  <p class="station-name">{{ station?.name }}</p>
</div>
<div *ngIf="notifications?.length" class="notification-area">
  <div class="notification">
    <app-notifications [notifications]="notifications" [switchTime]="switchTime" [track]="true"></app-notifications>
  </div>
</div>
